module.exports = __webpack_public_path__ + "static/media/water-bg.2a310fec.jpeg";